import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ConsultationCard from "./CompanyCard";
import MoreModal from "../../../globalComponents/MoreModal/MoreModal";
import ConfirmModal from "../../../globalComponents/ConfirmModal/ConfirmModal";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import moment from "moment";
import CompanyCard from "./CompanyCard";

const CompanyData = ({ getNextCompanies, userData }) => {
  const { hasMore, companyData } = useSelector(
    (state) => state.companyPagination,
  );
  const [openMoreModal, setOpenMoreModal] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(1);

  const tableHead = [
    "Şirkətin adı",
    "Direktor adı, soyadı",
    "Şirkətin vöeni",
    "Bankın adı",
    "M/H",
    "Bankın vöeni",
    "Bank kodu",
    "SWIFT",
    "H/H",
    "Satış növü",
    "Müqavilə başlama tarixi",
    "Müqavilə bitmə tarixi",
    "Ödəniş tarixi",
    "Ödəniş",
    "Müqavilənin əlavəsi",
    "İmzalanmış müqavilə",
    "Status",
    "",
  ];

  useEffect(() => {
    if (openMoreModal) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "overlay";
    }
  }, [openMoreModal]);

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight,
      );
    };

    setScrollHeight(
      window.innerHeight - mainHeader.offsetHeight - detailsHeader.offsetHeight,
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <>
        <div className="table-con">
          <InfiniteScroll
            style={{ overflowX: "none" }}
            dataLength={companyData.length}
            next={getNextCompanies}
            hasMore={hasMore}
            loader={<SmallLoading />}
            endMessage={
              <p style={{ textAlign: "center", fontSize: "20px" }}></p>
            }
            height={scrollHeight}
            scrollThreshold={0.7}
          >
            <table className="details-table consultation-page ">
              <thead>
                <tr>
                  {tableHead.map((head, i) => (
                    <th
                      className={`table-head-w`}
                      key={i}
                      style={{
                        textAlign: "start",
                        minWidth:
                          i <= 7
                            ? "200px"
                            : i <= 11
                              ? "150px"
                              : i == 15 || i == 14
                                ? "260px"
                                : "auto",
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {companyData?.map((company, i) => (
                  <CompanyCard
                    key={company._id}
                    data={company}
                    mode="desktop"
                    consultation={userData}
                    setOpenMoreModal={setOpenMoreModal}
                    cellNumber={i + 1}
                  />
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </>
    </>
  );
};

export default CompanyData;
